import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { flex } from '../../../../utils/flex.vanilla.mjs';
import { definitionList } from './definitionList.vanilla.mjs';

const TooltipDefinitionList = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(
    definitionList,
    flex({ direction: "column", align: "stretch" }),
    classNameFromProps
  );
  return /* @__PURE__ */ jsx(
    "dl",
    {
      "data-scope": "tooltip",
      "data-part": "definition-list",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});
TooltipDefinitionList.displayName = "Tooltip.DefinitionList";

export { TooltipDefinitionList };
//# sourceMappingURL=DefinitionList.mjs.map
